import React, { useMemo } from "react";
import { Card, Typography, Divider } from "@mhome/ui";
import { alpha } from "@mui/material/styles";
import { useSetRecoilState, useRecoilValue } from "recoil";
import { selectedPromptIdState, promptOverridesState } from "../global-state";
import PromptDisplay from "../assistant/PromptDisplay";
import { useComponentBackgroundColor } from "../common/adaptive-theme-provider";

const ChatLanding = () => {
  const setSelectedPromptId = useSetRecoilState(selectedPromptIdState);
  const getComponentBgColor = useComponentBackgroundColor();
  const promptOverrides = useRecoilValue(promptOverridesState);

  // Build suggestions from prompt overrides only
  const suggestions = useMemo(() => {
    // Filter to only show prompts marked for landing page
    return promptOverrides.filter((p) => p.showOnLanding);
  }, [promptOverrides]);

  return (
    <div style={{ marginLeft: "4px", marginRight: "4px" }}>
      <Card
        style={{
          marginBottom: "24px",
          padding: "16px",
          backgroundColor: getComponentBgColor("hsl(var(--card))"),
        }}
      >
        <div style={{ marginBottom: "16px" }}>
          <Typography
            variant="h6"
            style={{
              color: "hsl(var(--foreground))",
              fontWeight: 600,
              fontSize: "1.1rem",
            }}
          >
            How can I assist you today?
          </Typography>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "12px",
          }}
        >
          {suggestions.map((item) => (
            <Card
              key={item.title}
              onClick={() => setSelectedPromptId(item.id)}
              style={{
                padding: "12px",
                cursor: "pointer",
                backgroundColor: "transparent",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                boxShadow: "none",
                border: "1px solid hsl(var(--border) / 0.4)",
                borderRadius: "16px",
                fontSize: "0.875rem",
                transition: "all 0.2s ease-in-out",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "hsl(var(--accent))";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "transparent";
              }}
            >
              <PromptDisplay text={item.title} />
            </Card>
          ))}
        </div>
      </Card>
    </div>
  );
};

export default ChatLanding;
